import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { GetAllCurrencyResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent extends CommonService implements OnInit{
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;
  getAllCurrencyData          : any[]=[];
  isAdd                       : boolean = false;

  copyGetAllCurrencyData          : any[]=[];
  editCurrencyData                = new GetAllCurrencyResponseModel();

constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}

ngOnInit(): void {
  this.getAllCurrencyList();
}

add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
  const obj = {id:0, name:'',active:true,noOfDecimalPlaces:null,description:'',symbol:'',isDefault:true}
  this.getAllCurrencyData?.push(obj);
  this.copyGetAllCurrencyData?.push(obj);
  setTimeout(()=>{
    const element = document.getElementById(`currencyName${obj.id}`);
    element?.focus();
  },0)
}

cancel(){
  if(this.isAdd)
  {
    this.isAdd = false;
    this.getAllCurrencyData = this.getAllCurrencyData.filter((x)=>x.id != 0);
    this.copyGetAllCurrencyData = this.copyGetAllCurrencyData.filter((x)=>x.id != 0);
  }
  else if(this.editCurrencyData?.id && this.editCurrencyData?.isEdit){
    const index = this.copyGetAllCurrencyData.findIndex((x)=>x.id == this.editCurrencyData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllCurrencyData))[index];
    this.getAllCurrencyData[index] = singleData;
    this.editCurrencyData = new GetAllCurrencyResponseModel();
  }  
}

edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editCurrencyData = {...item};
}


checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
}


  // *********** CURRENCY API START *********
  // **********get all Currency *********
  getAllCurrencyList() {
    this.administrationService.getAllCurrencyData = [];
    this.administrationService.getAllCurrency().subscribe({
      next:(res)=>{
        if(res.isSuccess){
          this.getAllCurrencyData = res.response??[];
          this.editCurrencyData = new GetAllCurrencyResponseModel();
          this.copyGetAllCurrencyData = JSON.parse(JSON.stringify(this.getAllCurrencyData))??[];
          this.administrationService.getAllCurrencyData = JSON.parse(JSON.stringify(this.getAllCurrencyData))??[];
        }else{           
          this.getAllCurrencyData = [];
          this.copyGetAllCurrencyData = [];
        }  
      },
      error:(err)=>{
        this.getAllCurrencyData = [];
        this.copyGetAllCurrencyData = [];
      }
    })
  }
  
 // *************insert Currency **************
  InserCurrencyList(item) {
    const {id , ...rest} = item;
    this.administrationService.insertCurrency(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            this.isAdd = false;
            this.getAllCurrencyList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }

  // **********update Currency *********
    UpdateCurrencyList(item) {
    const {isEdit , ...rest} = item;
    this.administrationService.updateCurrency(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            
            this.isAdd = false;
            this.getAllCurrencyList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }  

    // **********delete Currency *********
    DeleteCurrencyList(id) {
    if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
      this.administrationService.deleteCurrency(id)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.getAllCurrencyList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
      });
    }
  
  // *********** CURRENCY API END *********



}


